import React, {
  useState
} from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ProjectDocuments,
  ProjectInfoCard,
  ProjectPageHeader,
  ProjectSection
} from "apps/school-site/features/projects";

import {
  qualificationsProject,
  qualificationsGoal,
  qualificationsScope,
  qualificationsEffects,
  qualificationsSchedules,
  qualificationsTasks,
  qualificationsDocuments
} from "./data/qualificationsProjectData";


const QualificationsProjectPage = () => {
  const [expandedTask, setExpandedTask] = useState(null);

  const toggleTask = (taskId) => {
    setExpandedTask((current) =>
      current === taskId
        ? null
        : taskId
    );
  };

  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <ProjectPageHeader
            title="Wyższe kwalifikacje, lepsze perspektywy"
            description="CKZiU w Wyrzysku kształci zawodowców."
          />
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectInfoCard
                title={qualificationsProject.title}
                description={qualificationsProject.description}
                image={qualificationsProject.image}
              >
                <Content>
                  <p>
                    <strong>Numer projektu:</strong>{" "}
                    {qualificationsProject.projectNumber}
                  </p>

                  <p>
                    <strong>Okres realizacji:</strong>{" "}
                    {qualificationsProject.period}
                  </p>

                  <p>
                    <strong>Całkowita wartość projektu:</strong>{" "}
                    {qualificationsProject.value}
                  </p>

                  <p>
                    <strong>Wkład Funduszy Europejskich:</strong>{" "}
                    {qualificationsProject.funding}
                  </p>

                  {qualificationsProject.programme?.length > 0 && (
                    <>
                      <p>
                        <strong>
                          Projekt realizowany w ramach:
                        </strong>
                      </p>

                      <List isPlain>
                        {qualificationsProject.programme.map(
                          (item) => (
                            <ListItem key={item}>
                              {item}
                            </ListItem>
                          )
                        )}
                      </List>
                    </>
                  )}
                </Content>
              </ProjectInfoCard>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Cel projektu">
                <Content>
                  <p>
                    {qualificationsGoal}
                  </p>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Projekt polega na">
                <Content>
                  <List>
                    {qualificationsScope.map((item) => (
                      <ListItem key={item}>
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Planowane efekty projektu">
                <Content>
                  <List>
                    {qualificationsEffects.map((item) => (
                      <ListItem key={item}>
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        {qualificationsSchedules.length > 0 && (
          <StackItem>
            <Grid>
              <GridItem
                span={12}
                md={10}
                mdOffset={1}
              >
                <ProjectDocuments
                  title="Harmonogramy"
                  documents={qualificationsSchedules}
                />
              </GridItem>
            </Grid>
          </StackItem>
        )}

        {qualificationsDocuments.length > 0 && (
          <StackItem>
            <Grid>
              <GridItem
                span={12}
                md={10}
                mdOffset={1}
              >
                <ProjectDocuments
                  title="Pliki do pobrania"
                  documents={qualificationsDocuments}
                />
              </GridItem>
            </Grid>
          </StackItem>
        )}

        {qualificationsTasks.length > 0 && (
          <StackItem>
            <Grid>
              <GridItem
                span={12}
                md={10}
                mdOffset={1}
              >
                <ProjectSection
                  title="Szczegółowy harmonogram udzielenia wsparcia"
                >
                  <Accordion>
                    {qualificationsTasks.map((task) => {
                        const isExpanded =
                        expandedTask === task.id;

                        return (
                        <AccordionItem
                            key={task.id}
                            isExpanded={isExpanded}
                        >
                            <AccordionToggle
                            id={`${task.id}-toggle`}
                            onClick={() =>
                                toggleTask(task.id)
                            }
                            >
                            Zadanie {task.number}.{" "}
                            {task.title}
                            </AccordionToggle>

                            <AccordionContent
                            id={`${task.id}-content`}
                            aria-labelledby={`${task.id}-toggle`}
                            >
                            <Stack hasGutter>
                                {(task.period ||
                                task.location ||
                                task.duration) && (
                                <StackItem>
                                    <Content>
                                    {task.period && (
                                        <p>
                                        <strong>
                                            Okres realizacji:
                                        </strong>{" "}
                                        {task.period}
                                        </p>
                                    )}

                                    {task.location && (
                                        <p>
                                        <strong>
                                            Miejsce realizacji:
                                        </strong>{" "}
                                        {task.location}
                                        </p>
                                    )}

                                    {task.duration && (
                                        <p>
                                        <strong>
                                            Czas trwania:
                                        </strong>{" "}
                                        {task.duration}
                                        </p>
                                    )}
                                    </Content>
                                </StackItem>
                                )}

                                {task.description && (
                                <StackItem>
                                    <Content>
                                    <p>
                                        {task.description}
                                    </p>
                                    </Content>
                                </StackItem>
                                )}

                                {task.sections?.map(
                                (section, index) => (
                                    <StackItem
                                    key={`${task.id}-section-${index}`}
                                    >
                                    <Content>
                                        {section.title && (
                                        <h4>
                                            {section.title}
                                        </h4>
                                        )}

                                        {section.description && (
                                        <p>
                                            {section.description}
                                        </p>
                                        )}

                                        {section.items?.length > 0 && (
                                        <List>
                                            {section.items.map(
                                            (item) => (
                                                <ListItem key={item}>
                                                {item}
                                                </ListItem>
                                            )
                                            )}
                                        </List>
                                        )}
                                    </Content>
                                    </StackItem>
                                )
                                )}
                            </Stack>
                            </AccordionContent>
                        </AccordionItem>
                        );
                    })}
                    </Accordion>
                </ProjectSection>
              </GridItem>
            </Grid>
          </StackItem>
        )}
      </Stack>
    </PageSection>
  );
};

export default QualificationsProjectPage;